import * as notifications from "utils/notifications";
import { escapeHtml } from "utils/security";

export async function notifyAboutFailureOrReloadPage(response: Response): Promise<void> {
  if (response.ok) {
    await response.text();
    window.location.reload();
  } else {
    await notifyAboutFailure(response);
  }
}

export async function parseError(response: Response): Promise<string> {
  try {
    const data = await response.clone().json();
    return data.error;
  } catch (e) {
    return await response.clone().text();
  }
}

export async function notifyAboutFailure(response: Response): Promise<void> {
  if (!response.ok) {
    notifications.alert(await parseError(response));
  }
}

export function parseErrorFromJson(errorData: unknown): string {
  if (!errorData) {
    return "Failed to process request";
  }

  if (typeof errorData === "string") {
    return escapeHtml(errorData);
  }

  if (Array.isArray(errorData)) {
    return errorData.map((msg) => escapeHtml(String(msg))).join(", ");
  }

  if (typeof errorData === "object" && !Array.isArray(errorData)) {
    const errorMessages: string[] = [];
    for (const field in errorData) {
      const fieldErrors = (errorData as Record<string, unknown>)[field];
      if (Array.isArray(fieldErrors)) {
        errorMessages.push(...fieldErrors.map((msg) => escapeHtml(String(msg))));
      } else if (typeof fieldErrors === "string") {
        errorMessages.push(escapeHtml(fieldErrors));
      }
    }
    return errorMessages.length > 0 ? errorMessages.join(", ") : "Validation failed";
  }

  return "An error occurred";
}
